import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import { Link } from 'react-router-dom';

import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { GET_SEEKER_TRANSPORTERS, CLEAR_SEEKER_TRANSPORTERS_LOADING } from 'Constants/actionConstants';

import TransportersTable from 'Components/TransportersTable';
import ActionLoader from 'Components/ActionLoader/index';
import { HIKAL } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

class TransportersListing extends Component {
    state = {
        isChallengePriceShown : false,
        selectedBids: []
    }
    seekerTransportersTimer = null;
    getSeekerTransporters = (filters={})=> {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_SEEKER_TRANSPORTERS,
            params: {
                rfqId: match.params.id,
                ...filters
            },
            onSuccess: this.setSeekerTransportersTimer     
        })
    }
    setSeekerTransportersTimer = ()=> {
        if(this.unmounted) {return};
        if(this.seekerTransportersTimer) {
            clearTimeout(this.seekerTransportersTimer);
        }
        this.seekerTransportersTimer = setTimeout(()=> {
            this.getSeekerTransporters()
        }, 10000);
    }
    fetchTransporters = (filters)=> {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_SEEKER_TRANSPORTERS_LOADING
        });
        this.getSeekerTransporters(filters);
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_SEEKER_TRANSPORTERS_LOADING
        })
        this.getSeekerTransporters();
    }
    componentWillUnmount = ()=> {
        this.unmounted = true;
        clearTimeout(this.seekerTransportersTimer)
    }
    render() {
        const { transporters, isTransportersLoading, rfq, paymentCycles, pricingBasis } = this.props;
        const rfqId = this.props.match.params.id;
        return (
            <div>
                {isTransportersLoading && (transporters || []).length === 0 && <ActionLoader fixed={true}/>}
                <Sticky>    
                    {rfq && <Link to="/" className="ht-60 flex flex-middle pl-40">
                        <BackIcon className="mr-10 fill-theme curP"/>
                        {rfq && <div className="header-dark-color fs-16 fBold">{rfq.rfqDetails.name}</div>}
                    </Link>}
                    {rfq && <div className="flex ht-60 flex-middle box-shadow pl-80 mb-40">
                        <Link to={"/seeker/bids/" + rfqId + "/" + rfq.type} className="fSemibold header-medium-color fs-16 row-100 flex flex-middle curP mr-40">Bids</Link>
                        <Link to = {"/seeker/bids/transporters/list/" + rfqId} className="fBold header-dark-color border-bottom-theme-4 fs-16 row-100 flex flex-middle">{HIKAL.includes(getUser().companyId) ? 'Recipients': ([9].includes(rfq.type) ? 'Buyers': 'Transporters')}</Link>
                    </div>}
                    {rfq && 
                    <TransportersTable 
                        setBids={this.setBids} 
                        transporters = {transporters}
                        fetchTransporters = {this.fetchTransporters}
                        rfqId={rfq.id}
                        paymentCycles={paymentCycles}
                        pricingBasis={pricingBasis}
                        rfqType={rfq.type}
                        rfq={rfq}
                    />}
                </Sticky>
            </div>
        )
    }
}


const mapStateToProps = ({constants, contracting}) => {
    return {
        transporters: contracting.transportersList.data || [],
        isTransportersLoading: contracting.transportersList.dataLoading,
        rfq: contracting.transportersList.rfq,

        paymentCycles: constants.paymentCycles || [],
        businessVolumes: constants.businessVolumes || [],
        pricingBasis: constants.pricingBasis || [],
        slabs: constants.slabs || [],
    }
};


export default connect(mapStateToProps)(TransportersListing);